import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import IndexSectionHeadersWhitePattern1 from '../components/headers-white-pattern/IndexSectionHeadersWhitePattern1';
import IndexSectionDashboardBanners2 from '../components/dashboard-banners/IndexSectionDashboardBanners2';
import IndexSectionHowItWorksWhitePattern4 from '../components/how-it-works-white-pattern/IndexSectionHowItWorksWhitePattern4';
import IndexSectionFaqsDarkPattern6 from '../components/faqs-dark-pattern/IndexSectionFaqsDarkPattern6';
import IndexSectionBlogContentDarkPattern9 from '../components/blog-content-dark-pattern/IndexSectionBlogContentDarkPattern9';
import IndexSectionCtaWhitePattern10 from '../components/cta-white-pattern/IndexSectionCtaWhitePattern10';
import IndexSectionCareersWhitePattern11 from '../components/careers-white-pattern/IndexSectionCareersWhitePattern11';
import IndexSectionFootersGrayPattern7 from '../components/footers-gray-pattern/IndexSectionFootersGrayPattern7';

const meta = {
  title: 'FINA\u0020Kreditorenbuchhaltung',
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function Index() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <IndexSectionHeadersWhitePattern1 />
      <IndexSectionDashboardBanners2 />
      <IndexSectionHowItWorksWhitePattern4 />
      <IndexSectionFaqsDarkPattern6 />
      <IndexSectionBlogContentDarkPattern9 />
      <IndexSectionCtaWhitePattern10 />
      <IndexSectionCareersWhitePattern11 />
      <IndexSectionFootersGrayPattern7 />
    </React.Fragment>
  );
}

